import React from 'react';
import Notes from 'Components/Notes';

export default function NotesSection ({user, notes, handleInputChange}) {
  if (notes || user.isInternal()) {
    return (
      <section className='scene_section'>
        <header>
          Notes
        </header>
        <Notes text={notes || ''} handleInputChange={handleInputChange('notes')} disabled={!user.isInternal()} />
      </section>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/Application/Edit/Notes.jsx